'use client';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["colorSet", "className", "isMobile", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { addColorSet, deprecatedOverlayDirections } from "../../styles/index.mjs";
import { TypeList } from "../TypeList/index.mjs";
import { PopoverDesktop } from "./PopoverDesktop.mjs";
import { PopoverMobile } from "./PopoverMobile.mjs";
function PopoverNavigationComponent(_ref) {
  var _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'base' : _ref$colorSet,
    className = _ref.className,
    isMobile = _ref.isMobile,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var Popover = isMobile ? PopoverMobile : PopoverDesktop;
  return /*#__PURE__*/React.createElement(Popover, Object.assign({
    className: addColorSet(colorSet, className),
    colorSet: colorSet
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.PopoverNavigation
  }), /*#__PURE__*/React.createElement(TypeList, {
    condensedAll: true,
    listStyleReset: true
  }, children));
}
var popoverNavigationHelpers = _objectSpread({}, deprecatedOverlayDirections);

/**
* **PopoverNavigation** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/PopoverNavigation) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=291:1143)
*
* A popover that renders a simple list of PopoverNavigationLinks
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/popover?format=figma-figma#popovernavigation)
*
* @example
* () => (
*  <PopoverNavigation arrow="bottomEnd">
*    <PopoverNavigationItem>
*      <PopoverNavigationLink href="/details">View Details</PopoverNavigationLink>
*    </PopoverNavigationItem>
*    <PopoverNavigationItem>
*      <PopoverNavigationLink onClick={() => {}}>Share</PopoverNavigationLink>
*    </PopoverNavigationItem>
*  </PopoverNavigation>
*);
*
*/
export var PopoverNavigation = Object.assign(PopoverNavigationComponent, popoverNavigationHelpers);